module.exports = __webpack_public_path__ + "img/merci.cfa2a525.png";